import { useCallback } from 'react';
import { addMarker } from 'shared/utils/maps/add-marker.ts';
import { EMapMarkerType } from 'types/map';
import type { IGetMarketsParams } from 'components/map/map-container/hooks/types.ts';
import { useSetMarkers } from 'components/map/map-container/hooks/use-set-markers.ts';
import type { IUseSetAnonymousWaypointsMarkersOptions } from './types';

export const useSetAnonymousWaypointsMarkers = ({ map, waypoints }: IUseSetAnonymousWaypointsMarkersOptions) => {
  const getMarkers = useCallback(
    ({ markersRef }: IGetMarketsParams) => {
      if (!map || !waypoints) {
        return;
      }

      waypoints.forEach((waypoint) => {
        if (!waypoint.isWarehouse) {
          const marker = addMarker({
            type: EMapMarkerType.ANONYMOUS,
            map,
            position: {
              lat: waypoint?.lat ?? 0,
              lng: waypoint?.lng ?? 0,
            },
            title: '📦',
            isBelong: waypoint?.isBelong,
          });
          markersRef.current.push(marker);
        }
      });
    },
    [map, waypoints],
  );

  useSetMarkers({ map, getMarkers, withCluster: false });
};
